import { useId, type ReactNode } from 'react';

import { Field, FieldError, FieldLabel } from '@/components/ui/field';

/*
 * FormField (composed). Wires a label to its control for accessibility: the
 * generated id is passed to the control via a render prop and set as the
 * label's htmlFor, so `getByLabelText` / screen readers associate them.
 * Errors render through the stock FieldError (role="alert"). Domain-free: the
 * feature supplies the label, control, and error strings.
 */
export function FormField({
  label,
  errors,
  children,
}: {
  label: string;
  errors?: string[];
  children: (props: { id: string }) => ReactNode;
}) {
  const id = useId();
  const messages = (errors ?? []).filter(Boolean);

  return (
    <Field>
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      {children({ id })}
      {messages.length > 0 ? (
        <FieldError errors={messages.map((message) => ({ message }))} />
      ) : null}
    </Field>
  );
}
